import React from 'react';
import { CreditCardIcon, FileDownIcon, ShieldCheckIcon } from 'lucide-react';
import { productMockup } from '../data/landingContent';
import { Button } from './Button';
import { Container } from './Container';
export function Hero() {
  return <section className="bg-cream pb-12 pt-8 sm:pb-16 sm:pt-14" data-id="element-65" data-mp="9l375k8q6q7o">
      <Container className="flex flex-col items-center text-center" data-id="element-66" data-mp="4mrsmw7hjrj4">
        <span className="inline-flex items-center gap-2 rounded-full border border-navy/25 bg-white/60 px-4 py-2 text-[10px] font-bold uppercase tracking-[0.18em] text-navy sm:text-xs" data-id="element-67" data-mp="1297ahz3tqr77">
          <span className="h-1.5 w-1.5 rounded-full bg-navy" aria-hidden="true" data-id="element-68" data-mp="sbb2vha3iedu" />
          For elementary school counselors
        </span>

        <h1 className="mt-5 max-w-[900px] font-condensed text-[42px] font-extrabold uppercase leading-[0.95] tracking-[-0.01em] text-navy sm:mt-6 sm:text-[64px] lg:text-[76px]" data-id="element-69" data-mp="nb6llp1d5fmk">
          Teach your next counseling lesson <span className="text-teal" data-id="element-70" data-mp="381nrczkpyaz7">without planning from scratch.</span>
        </h1>

        <img src={productMockup} alt="School Counselor Lessons Ready: 36 ready lessons plus 5 bonuses, shown on desktop and tablets" width={1122} height={1402} className="mt-7 h-auto w-full max-w-[300px] rounded-3xl shadow-[0_24px_50px_rgba(23,50,77,0.18)] sm:mt-10 sm:max-w-[420px]" data-id="element-71" data-mp="3j9kbdcsl9jgn" />

        <Button href="#offer-details" variant="teal" className="mt-8 w-full max-w-[520px] sm:mt-10" data-id="element-72" data-mp="3eb8zyxmnb0wb">
          Get the lesson book
        </Button>

        <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-[14px] text-muted sm:mt-6" data-id="element-73" data-mp="359t03jtgih6c">
          <li className="flex items-center gap-1.5" data-id="element-74" data-mp="2ql6a8o67e70v">
            <FileDownIcon aria-hidden="true" className="h-4 w-4 text-navy" data-id="element-75" data-mp="2viy3pmmhy176" /> PDF download
          </li>
          <li className="flex items-center gap-1.5" data-id="element-76" data-mp="2hjf79r31seap">
            <CreditCardIcon aria-hidden="true" className="h-4 w-4 text-navy" data-id="element-77" data-mp="2hjoxnfs08ngx" /> One-time payment
          </li>
          <li className="flex items-center gap-1.5" data-id="element-78" data-mp="2ljz5yz39rpyy">
            <ShieldCheckIcon aria-hidden="true" className="h-4 w-4 text-navy" data-id="element-79" data-mp="s2b8o0ipgn67" /> 10-day guarantee
          </li>
        </ul>
      </Container>
    </section>;
}